<template>
    <BaseModal
        ref="twoAuthSetupModal"
        v-model="missingBirthday"
        :title="$t('users.missingBirthday')">
        <VForm
            v-slot="validation"
            @submit="saveUserBirthday">
            <BaseAlert
                color="warning"
                class="mb-4">
                {{ $t('users.missingBirthdayDescription') }}
            </BaseAlert>
            <BaseDatePicker
                v-model="userBirthday"
                :name="$t('users.attributes.birthday')"
                :label="$t('users.attributes.birthday')"
                rules="required"
                required />
            <BaseSubmitButtons
                :validation="validation"
                :loading="loading"
                hide-cancel-button />
        </VForm>
    </BaseModal>
</template>

<script setup lang="ts">
import {useAuthStore} from "~/store/auth"

const authStore = useAuthStore()
const {$apiRoute} = useNuxtApp()
const notification = useNotification()
const {t: $t} = useI18n()

const missingBirthday = ref<boolean>(false)
const userBirthday = ref<string>('')
const loading = ref<boolean>(false)

async function saveUserBirthday() {
    if (!userBirthday.value || !authStore.userData?.id) return
    loading.value = true

    const response = await $lara.put($apiRoute('spa.users.update', {
        user: authStore.userData?.id,
    }), {
        body: {
            birthday: userBirthday.value,
            only: 'birthday',
        }
    })

    loading.value = false

    if (response?.error) return notification.error($t('users.couldNotBeSaved'))

    notification.success($t('users.savedSuccessfully'))
    await authStore.getAuthData()
    missingBirthday.value = false
}

onMounted(() => {
    missingBirthday.value = !authStore.userData?.birthday
})
</script>